//
//
//
//
//
//
//
//
export default {
  name: 'CollectionBattle',
  props: {
    payload: {
      type: Object,
      required: true
    }
  }
};